import { z } from 'zod';

export const CONTACT_TOPICS = [
  'general',
  'support',
  'privacy',
  'security',
  'press',
  'partnership',
  'careers',
  'legal',
  'other',
] as const;

export type ContactTopic = (typeof CONTACT_TOPICS)[number];

/** Labels 1:1 aus contact.html (Select-Optionen). */
export const CONTACT_TOPIC_LABELS: Record<ContactTopic, string> = {
  general: 'Allgemeine Frage / Produkt-Demo / Feedback',
  support: 'Hilfe bei der Nutzung / technisches Problem',
  privacy: 'Datenschutz / DSGVO-Anfrage / Auskunft / Löschung',
  security: 'Sicherheits-Meldung / Vulnerability Disclosure',
  press: 'Presse-Anfrage / Interview',
  partnership: 'Partnerschaft / Kooperation',
  careers: 'Initiativbewerbung / Karriere',
  legal: 'Rechtlich verbindliche Anliegen → siehe Impressum',
  other: 'Sonstiges',
};

/* Bewerbungs-Anhänge – NUR beim `careers`-Topic. Die Dateien werden als BINÄRE
   FormData an die Server-Action geschickt (NICHT als Base64 im JSON-Payload):
   Base64 bläht ~4 MB auf ~5,4 MB auf und sprengt Vercels Request-Body-Limit von
   ~4,5 MB → 413 am Ingress, bevor der Code läuft. Deshalb transportieren wir
   binär und cappen das GESAMT-Volumen ehrlich auf 4 MB (passt unter das
   Function-Limit inkl. Multipart-Overhead). Für echte 15 MB müssten die PDFs
   per Direkt-Upload in einen ephemeren Storage-Bucket (Folge-PR, Storage-
   Contract) – bewusst noch NICHT gebaut. Das Mail-Provider-Limit (~20 MB) ist
   hier nicht der Engpass. */
export const MAX_ATTACHMENT_BYTES = 4 * 1024 * 1024; // pro Datei
export const MAX_ATTACHMENTS_TOTAL_BYTES = 4 * 1024 * 1024; // gesamt (Transport-Limit)
export const MAX_ATTACHMENT_COUNT = 5;

/* Nur die Textfelder werden per Zod validiert (Client-Resolver + Server). Die
   Anhänge reisen als binäre FormData-Files und werden server-seitig manuell
   gehärtet (PDF-Magic-Bytes + Grössen-Caps) – s. server-actions.ts. */
export const ContactSchema = z.object({
  topic: z.enum(CONTACT_TOPICS),
  name: z.string().min(1, 'Pflichtfeld').max(200),
  email: z.string().email('Ungültige E-Mail-Adresse'),
  message: z.string().min(1, 'Pflichtfeld').max(5000),
  // Honeypot: für Menschen unsichtbar, Form liefert immer '' – gefüllt = Bot.
  company: z.string().max(200),
});

export type ContactInput = z.infer<typeof ContactSchema>;
